import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import { IFullVideoProps } from "../gridLayout2/FullWidthPromoModules"
import ProductFooter from "../footer/ProductFooter"

const FullVideo: React.FC<IFullVideoProps> = ({
  playIcon,
  videoEmbedUrl,
  footer,
  videoThumbNail,
}) => {
  const gatsbyImage = playIcon && getImage(playIcon.gatsbyImage)
  const videoImage = videoThumbNail && getImage(videoThumbNail.gatsbyImage)
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className="relative mx-auto flex h-[517px] max-w-7xl flex-col justify-end bg-grey text-white">
      {gatsbyImage && (
        <button
          onClick={e => setIsPlaying(true)}
          className="absolute top-1/2 left-1/2 z-20 w-full -translate-x-1/2 -translate-y-1/2 cursor-pointer"
        >
          <GatsbyImage
            image={gatsbyImage}
            alt={playIcon.altText}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
          />
        </button>
      )}
      {videoImage && (
        <button
          onClick={e => setIsPlaying(true)}
          className="absolute top-0 left-0 z-10 h-full w-full"
        >
          <GatsbyImage
            image={videoImage}
            alt={videoThumbNail.altText}
            className={
              "absolute top-0 left-0 h-full w-full object-cover object-bottom"
            }
          />
        </button>
      )}

      {videoEmbedUrl && isPlaying && (
        <>
          <iframe
            title={videoEmbedUrl}
            loading="lazy"
            frameBorder="0"
            allow="autoplay"
            className={"absolute top-0 left-0 z-30 h-full w-full min-w-full"}
            src={
              videoEmbedUrl +
              "?controls=0&iv_load_policy=3&modestbranding=1&mute=0&autoplay=1"
            }
          ></iframe>
        </>
      )}

      {footer?.headline && <ProductFooter {...footer} />}
    </div>
  )
}

export default FullVideo

export const fragment = graphql`
  fragment FullVideo on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2 {
    fieldGroupName
    blocks {
      ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2_Blocks_Video {
        fieldGroupName
        playIcon {
          altText
          gatsbyImage(
            quality: 100
            placeholder: BLURRED
            width: 73
            height: 73
            formats: [AUTO, WEBP]
          )
        }
        videoEmbedUrl
        footer {
          headline
          link {
            target
            title
            url
          }
        }
        videoThumbNail {
          altText
          gatsbyImage(
            quality: 100
            layout: FULL_WIDTH
            width: 1226
            height: 517
            formats: [AUTO, WEBP]
          )
        }
      }
    }
  }
`
